export default __webpack_public_path__ + "static/media/heart-icon.69434215.svg";